/* ============================================================
   TCG Banlist — carga bajo demanda desde YGOPRODeck
   - Nunca descarga al cargar la página: solo al pulsar "Cargar lista"
   - Vista GALERÍA (imágenes de carta + badge prohibida/1/2 estilo Konami)
     y vista LISTA (texto en columnas), con filtro por nombre
   - Recorta a {nombre, estado, id} antes de cachear en sessionStorage
   ============================================================ */
(function () {
  'use strict';

  var CACHE_KEY = 'ygoBanlist2'; // v2: incluye id de carta para la imagen
  var API = '/apps/tcg/ygo?banlist=tcg';
  var IMG = 'https://images.ygoprodeck.com/images/cards_small/';
  var PAGE = 48; // cartas visibles por grupo antes de "Mostrar más"

  // OJO: YGOPRODeck usa "Forbidden" (no "Banned") para las prohibidas.
  var GROUPS = [
    { key: 'Forbidden', titulo: 'Prohibidas', badge: 'ban' },
    { key: 'Limited', titulo: 'Limitadas', badge: '1' },
    { key: 'Semi-Limited', titulo: 'Semi-limitadas', badge: '2' }
  ];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, self = this;
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function badgeHtml(tipo) {
    if (tipo === 'ban') return '<span class="tcg-banlist__badge tcg-banlist__badge--ban" aria-label="Prohibida"></span>';
    return '<span class="tcg-banlist__badge tcg-banlist__badge--num" aria-label="Límite ' + tipo + '">' + tipo + '</span>';
  }

  // Al hacer clic en una carta: resolvemos su producto real en la tienda (predictive
  // search) y vamos a su PDP. Si no hay match en stock, caemos a la búsqueda (href por defecto).
  function goToProduct(name, fallback, link) {
    if (link) link.classList.add('is-loading');
    var url = '/search/suggest.json?q=' + encodeURIComponent(name) +
      '&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var prods = j && j.resources && j.resources.results && j.resources.results.products;
        var p = prods && prods[0];
        window.location.href = (p && p.url) ? p.url : fallback;
      })
      .catch(function () { window.location.href = fallback; });
  }

  function init(root) {
    if (root.dataset.banlistBound) return;
    root.dataset.banlistBound = '1';

    var btn = root.querySelector('[data-banlist-load]');
    var out = root.querySelector('[data-banlist-result]');
    var filter = root.querySelector('[data-banlist-filter]');
    if (!btn || !out) return;

    var data = null;
    var view = 'gallery';
    var shown = {}; // grupo → cuántas visibles
    var controls = null;

    function resetShown() {
      GROUPS.forEach(function (g) { shown[g.key] = PAGE; });
    }

    function buildControls() {
      if (controls) return;
      controls = document.createElement('div');
      controls.className = 'tcg-banlist__views';
      controls.innerHTML =
        '<button type="button" class="tcg-banlist__view is-active" data-view="gallery">Galería</button>' +
        '<button type="button" class="tcg-banlist__view" data-view="list">Lista</button>';
      filter.parentNode.insertBefore(controls, filter);
      controls.addEventListener('click', function (e) {
        var b = e.target.closest('[data-view]');
        if (!b || b.dataset.view === view) return;
        view = b.dataset.view;
        controls.querySelectorAll('.tcg-banlist__view').forEach(function (x) {
          x.classList.toggle('is-active', x.dataset.view === view);
        });
        resetShown();
        render();
      });
    }

    function filtered() {
      var q = ((filter && filter.value) || '').toLowerCase().trim();
      var groups = {};
      GROUPS.forEach(function (g) { groups[g.key] = []; });
      data.forEach(function (c) {
        if (q && c.n.toLowerCase().indexOf(q) === -1) return;
        if (groups[c.b]) groups[c.b].push(c);
      });
      return groups;
    }

    function galleryGroup(g, cards) {
      var visible = cards.slice(0, shown[g.key]);
      var html =
        '<h4 class="tcg-banlist__group">' + badgeHtml(g.badge) + ' ' + g.titulo +
        ' <span>(' + cards.length + ')</span></h4>' +
        '<div class="tcg-banlist__grid">' +
        visible.map(function (c) {
          return '<figure class="tcg-banlist__card" title="' + esc(c.n) + '">' +
            badgeHtml(g.badge) +
            '<a class="tcg-banlist__cardlink" href="/search?type=product&q=' + encodeURIComponent(c.n) + '" data-card-name="' + esc(c.n) + '">' +
            (c.i
              ? '<img src="' + IMG + c.i + '.jpg" alt="' + esc(c.n) + '" loading="lazy" width="168" height="245" onerror="this.style.visibility=\'hidden\'">'
              : '<span class="tcg-banlist__noimg"></span>') +
            '<figcaption>' + esc(c.n) + '</figcaption>' +
            '</a>' +
            '</figure>';
        }).join('') +
        '</div>';
      if (cards.length > shown[g.key]) {
        html += '<button type="button" class="tcg-banlist__more" data-more="' + g.key + '">Mostrar más (' +
          (cards.length - shown[g.key]) + ' restantes)</button>';
      }
      return html;
    }

    function listGroup(g, cards) {
      return '<h4 class="tcg-banlist__group">' + badgeHtml(g.badge) + ' ' + g.titulo +
        ' <span>(' + cards.length + ')</span></h4>' +
        '<ul class="tcg-banlist__list">' +
        cards.map(function (c) { return '<li>' + esc(c.n) + '</li>'; }).join('') +
        '</ul>';
    }

    function render() {
      if (!data) return;
      var groups = filtered();
      var total = 0;
      var html = GROUPS.map(function (g) {
        var cards = groups[g.key];
        total += cards.length;
        if (!cards.length) return '';
        return view === 'gallery' ? galleryGroup(g, cards) : listGroup(g, cards);
      }).join('');
      out.innerHTML = total
        ? html
        : '<p class="tcg-banlist__error">Sin resultados para esa búsqueda.</p>';
    }

    out.addEventListener('click', function (e) {
      var more = e.target.closest('[data-more]');
      if (!more) return;
      shown[more.dataset.more] += PAGE * 2;
      render();
    });

    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = 'Cargando…';

      var cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(CACHE_KEY)); } catch (e) {}

      var promise = cached
        ? Promise.resolve(cached)
        : fetch(API)
            .then(function (r) { if (!r.ok) throw new Error('banlist http ' + r.status); return r.json(); })
            .then(function (j) {
              var slim = (j.data || [])
                .map(function (c) {
                  return { n: c.name, b: (c.banlist_info && c.banlist_info.ban_tcg) || '', i: c.id || 0 };
                })
                .filter(function (c) { return c.b; })
                .sort(function (a, b) { return a.n.localeCompare(b.n); });
              try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(slim)); } catch (e) {}
              return slim;
            });

      promise
        .then(function (slim) {
          data = slim;
          btn.hidden = true;
          if (filter) filter.hidden = false;
          resetShown();
          buildControls();
          render();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Reintentar';
          out.innerHTML = '<p class="tcg-banlist__error">No se pudo cargar la lista. Revisa tu conexión e intenta de nuevo.</p>';
        });
    });

    if (filter) {
      filter.addEventListener('input', debounce(function () { resetShown(); render(); }, 200));
    }
  }

  function scan() {
    document.querySelectorAll('[data-tcg-banlist]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
